import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Route, useHistory} from 'react-router-dom';
import can from './can';

const ProtectedRoute = ({subject, defaultPage, ...routeProps}) => {
  const history = useHistory();

  useEffect(() => {
    if (!can('view', subject)) {
      history.replace(defaultPage);
    }
  }, [subject, defaultPage, history]);

  return <Route {...routeProps}/>
};

ProtectedRoute.propTypes = {
  subject: PropTypes.string,
  defaultPage: PropTypes.string,
  children: PropTypes.node
};

export default ProtectedRoute;
